import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledLayout = styled.div`
  main {
    text-align: center;
    min-height: 90vh;
    margin: auto;
  }
  > div.loading {
    z-index: 999999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.opaque};
    display: flex;
    gap: 1rem;
    //only smartphone
    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }
    img {
      width: 50px;
    }
    .loadingMessage {
      padding: 1rem;
      border-radius: 12px;
      background-color: white;
      color: ${COLORS.primary};
      font-size: 16px;
      max-width: 250px;
      text-align: center;
    }
  }
`;

export {
  StyledLayout
}
